import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

const DuplicaModale = ({ open, setOpen, idUID, setLoadingPage }) => {
  const isUnder600px = useMediaQuery("(max-width:768px)");
  const theme = useTheme();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message: message, severity: severity }));
  };

  const [formData, setFormData] = useState({
    nPolizza: "",
    nome: "",
    codice: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({ nPolizza: "", nome: "", codice: "" });
  };

  const handleDuplica = async () => {
    const newErrors = {
      nPolizza: formData.nPolizza === "" ? true : false,
      nome: formData.nome === "" ? true : false,
      codice: formData.codice === "" ? true : false,
    };
    setErrors(newErrors);

    // Check if all fields are valid
    const isValid = !Object.values(newErrors).includes(true);
    if (isValid) {
      await lmDuplicate({
        libroMatricola: {
          idUID: idUID,
          numeroPolizza: formData.nPolizza,
          nome: formData.nome,
          codice: formData.codice,
        },
      });
      return;
    } else {
      handleSnackbar("I valori non possono essere vuoti.", "error");
      return;
    }
    //Validazione
    /* if (!nameError) {
        servicesNewUpdate({
          scope: scopeCodice,
          nome: servizio,
          idStato: statoCodice,
        });
      } else {
        dispatch(
          showSnackbar({
            message: "Nome servizio non valido! Usa solo lettere e numeri.",
            severity: "error",
          })
        );
      } */
  };

  //LIbri matricola duplicate:
  // const json = {
  /* lmDuplicate: idUID, numeroPolizza, nome, codice */
  //Stato 0, finestra valorizzata
  //Stato 1, navigate con idUID nuovo

  async function lmDuplicate(data) {
    const token = sessionStorage.getItem("token");
    console.log(data);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: data,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/lmDuplicate`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
      } else {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.data.idUID) {
        handleClose();
        navigate(`/pages/libriMatricolaDetails/${responseData.data.idUID}`);
      }
      return;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  /* async function lmGetDetails(idUID) {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",    authorization: "Bearer " + token, 
        },
        body: JSON.stringify({
          token,
          data: {
            idUID: idUID === undefined ? "" : idUID,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/lmGetDetails`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      const data = responseData.data[0];
      setDataArray(data);
      formData(data);
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  } */

  return (
    <React.Fragment>
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "50vw", // Set your width here
              backgroundColor:
                theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
            },
          },
        }}
      >
        <DialogTitle>Duplica Libro Matricola</DialogTitle>
        <DialogContent>
          <form
            style={
              isUnder600px
                ? {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }
                : { display: "flex", alignItems: "center", gap: "16px" }
            }
          >
            <FormControl
              sx={{ mt: 2 }}
              m={2}
              style={{ minWidth: 120 }}
              size="small"
            >
              <TextField
                size="small"
                margin="none"
                label="N° Polizza"
                required
                fullWidth
                id="nPolizza"
                name="nPolizza"
                value={formData.nPolizza}
                error={errors.nPolizza}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl
              m={2}
              sx={{ mt: 2 }}
              style={{ minWidth: 120 }}
              size="small"
            >
              <TextField
                size="small"
                margin="none"
                label="Nome"
                required
                fullWidth
                id="nome"
                name="nome"
                value={formData.nome}
                error={errors.nome}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl
              m={2}
              sx={{ mt: 2 }}
              style={{ minWidth: 120 }}
              size="small"
            >
              <TextField
                size="small"
                margin="none"
                label="Codice"
                required
                fullWidth
                id="codice"
                name="codice"
                value={formData.codice}
                error={errors.codice}
                onChange={handleChange}
              />
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            sx={{ marginRight: "8px" }}
          >
            Chiudi
          </Button>
          <Button
            onClick={handleDuplica}
            variant="contained"
            sx={{ marginRight: "8px" }}
          >
            Duplica
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DuplicaModale;
